const locale =
  window.location.hostname === "demo.aiopinion.ai" ||
  window.location.hostname === "en-dev.demo.thirdopinion.ai"
    ? "en"
    : "ru";

document.title =
  locale === "ru" ? "Загрузка | Третье мнение" : "Loading | AI Opinion";

import Vue from "vue";
import moment from "moment";

// Or as a directive-only
import { VueMaskDirective } from "v-mask";
Vue.directive("mask", VueMaskDirective);

// IndexedDB
const indexedDB =
  window.indexedDB ||
  window.webkitIndexedDB ||
  window.mozIndexedDB ||
  window.OIndexedDB ||
  window.msIndexedDB;
const dbVersion = 1.0;

// Create/open database
const request = indexedDB.open("PTM_dicom_storage", dbVersion);

let db;

function putDicomToBD(blob, id) {
  console.log("Putting dicoms in IndexedDB");

  // Open a transaction to the database
  var transaction = db.transaction(["dicoms"], "readwrite");

  // Put the blob into the dabase
  return transaction.objectStore("dicoms").put(
    {
      id: id,
      blob: blob,
      time: moment.now(),
    },
    id
  );
}

function getDicomFromBD(id) {
  return new Promise((RESOLVE, REJECT) => {
    const transaction = db.transaction(["dicoms"], "readwrite");
    const getRequest = transaction.objectStore("dicoms").get(id);

    getRequest.onsuccess = (e) => {
      RESOLVE(e.target.result);
    };

    getRequest.onerror = () => {
      REJECT(null);
    };
  });
}

function putMetadataToBD(meta, id) {
  console.log("Putting dicoms meta in IndexedDB");

  // Open a transaction to the database
  var transaction = db.transaction(["dicoms_meta"], "readwrite");

  // Put the blob into the dabase
  return transaction.objectStore("dicoms_meta").put(meta, id);
}
function getMetadataFromBD(id) {
  return new Promise((RESOLVE, REJECT) => {
    const transaction = db.transaction(["dicoms_meta"], "readwrite");
    const getRequest = transaction.objectStore("dicoms_meta").get(id);

    getRequest.onsuccess = (e) => {
      RESOLVE(e.target.result);
    };

    getRequest.onerror = () => {
      REJECT(null);
    };
  });
}

// function getDicomFromBD (id) {
//   var transaction = db.transaction(["dicoms"], "readwrite");

//   transaction.objectStore("dicoms").get(id).onsuccess = (event) => {
//     return event.target.result;
//   };

// return new Promise(function(resolve, reject) {
//   // the function is executed automatically when the promise is constructed

//   // after 1 second signal that the job is done with the result "done"
//   setTimeout(() => resolve("done"), 1000);
// });
// }

function createObjectStore(dataBase) {
  // Create an objectStore
  console.log("Creating objectStore");
  dataBase.createObjectStore("dicoms");
  dataBase.createObjectStore("dicoms_meta");
}

function clearOld() {
  const transaction = db.transaction(["dicoms"], "readwrite");
  const getRequest = transaction.objectStore("dicoms").getAll();

  getRequest.onsuccess = function (result) {
    const dicoms = result.srcElement.result;

    if (dicoms && dicoms.length && dicoms[0] && !dicoms[0].id) {
      clearIDB();
      console.log("Обнаружены старые записи удаляем всю бд");
      return;
    }
    dicoms.map((dicom) => {
      if (moment.now() - dicom.time > 3600000) {
        console.log("обранужены дайкомы старше 3х часов в бд удаляем их");
        transaction.objectStore("dicoms").delete(dicom.id);
      }
    });
  };
}

function clearIDB() {
  const transaction = db.transaction(["dicoms"], "readwrite");
  const getRequest = transaction.objectStore("dicoms").clear();
}

request.onerror = function (event) {
  console.log("Error creating/accessing IndexedDB database");
};

request.onsuccess = function (event) {
  console.log("Success creating/accessing IndexedDB database");
  db = request.result;

  clearOld();

  Vue.prototype.$idb = {
    db,
    putDicomToBD,
    getDicomFromBD,
    getMetadataFromBD,
    putMetadataToBD,
    clearIDB,
  };

  db.onerror = function (event) {
    console.log("Error creating/accessing IndexedDB database");
  };

  // Interim solution for Google Chrome to create an objectStore. Will be deprecated
  if (db.setVersion) {
    if (db.version != dbVersion) {
      var setVersion = db.setVersion(dbVersion);
      setVersion.onsuccess = function () {
        createObjectStore(db);
      };
    }
  }
};

// For future use. Currently only in latest Firefox versions
request.onupgradeneeded = function (event) {
  createObjectStore(event.target.result);
};

import App from "./App.vue";
import router from "./router";
import store from "./store";
import Nprogress from "nprogress";
import Notifications from "vue-notification";
import velocity from "velocity-animate";

Vue.prototype.$moment = moment;

import debug from "Debug";
import accessModule from "AccessModule";

import Antd from "ant-design-vue";

import AuthLockBlock from "Components/AuthLockBlock";
Vue.component("AuthLockBlock", AuthLockBlock);

import VueUrlStateSync from "vue-url-state-sync";

import underscore from "vue-underscore";
Vue.use(underscore);

import VueTour from "vue-tour";

require("vue-tour/dist/vue-tour.css");

Vue.use(VueTour);

import * as Sentry from "@sentry/vue";

Sentry.init({
  Vue,
  dsn: "https://07b95dbfae6f433d9331a999488c4a05@sentry.dev.thirdopinion.ai//18",
  environment: process.env.NODE_ENV,
  defaultIntegrations: false,
});

import VueLazyload from "vue-lazyload";

// or with options
const loadimage = require("./assets/images/loading.png");

Vue.use(VueLazyload, {
  lazyComponent: true,
});

// import {
//   disable as disableDarkMode,
//   enable as enableDarkMode,
// } from "darkreader";

// Vue.prototype.$enableDarkMode = enableDarkMode;
// Vue.prototype.$disableDarkMode = disableDarkMode;

import VTooltip from "v-tooltip";

Vue.use(VTooltip);

import axios from "axios";
Vue.prototype.$axios = axios;

// enableDarkMode();

Vue.use(VueUrlStateSync);

Vue.use(Antd);

import VueI18n from "vue-i18n";

Vue.use(VueI18n);

Vue.prototype.$debug = debug;
Vue.prototype.$accessModule = accessModule;

Vue.config.productionTip = false;
if (process.env.NODE_ENV !== "production" || localStorage.developmentMode) {
  Vue.config.devtools = true;
  debug("Включен devtools", "warning");
}

router.beforeEach((to, from, next) => {
  Nprogress.start();
  //TODO: выпилить
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!store.getters.token) {
      if (
        window &&
        window.location &&
        (window.location.hash === "#demo" ||
          window.location.href.indexOf("share") !== -1)
      ) {
        next();
      } else {
        next();
      }
    } else {
      next();
    }
  } else {
    next();
  }
});
router.afterEach((to, from) => {
  Vue.nextTick(() => {
    if (window.ym) {
      const params = {
        title: document.title,
        referer: from.fullPath ? window.location.origin + from.fullPath : "",
      };

      window.ym(
        process.env.VUE_APP_YA_METRIC,
        "hit",
        window.location.href,
        params
      );

      debug(
        `YA METRICS: вызван hit метод ${process.env.VUE_APP_YA_METRIC} для страницы ${window.location.href}`,
        null,
        params
      );
    }
    Nprogress.done();
  });
});

Vue.use(Notifications, { velocity });

import messages from "./locales";

const i18n = new VueI18n({
  locale: locale,
  messages,
});

const Root = new Vue({
  i18n,
  router,
  store,
  render: (h) => h(App),
  mounted() {
    // You'll need this for renderAfterDocumentEvent.
    document.dispatchEvent(new Event("render-event"));
  },
}).$mount("#app");

accessModule("root", Root);

if (window.supportTimeout) {
  clearTimeout(window.supportTimeout);
  document.getElementById("notSupport").style.display = "none";
}
